export const userConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    GET_GETALLMESSAGETICKET_LIST_REQUEST: "GET_GETALLMESSAGETICKET_LIST_REQUEST",
    GET_GETALLMESSAGETICKET_LIST_SUCCESS: "GET_GETALLMESSAGETICKET_LIST_SUCCESS",
    GET_GETALLMESSAGETICKET_LIST_FAILURE: "GET_GETALLMESSAGETICKET_LIST_FAILURE",

    CHANGEADMIN_PASS_REQUEST: 'CHANGEADMIN_PASS_REQUEST',
    CHANGEADMIN_PASS_SUCCESS: 'CHANGEADMIN_PASS_SUCCESS',
    CHANGEADMIN_PASS_FAILURE: 'CHANGEADMIN_PASS_FAILURE',

    GET_LOGINHISTORY_LIST_REQUEST: "GET_LOGINHISTORY_LIST_REQUEST",
    GET_LOGINHISTORY_LIST_SUCCESS: "GET_LOGINHISTORY_LIST_SUCCESS",
    GET_LOGINHISTORY_LIST_FAILURE: "GET_LOGINHISTORY_LIST_FAILURE",

    GET_SWAPPING_LIST_REQUEST: "GET_SWAPPING_LIST_REQUEST",
    GET_SWAPPING_LIST_SUCCESS: "GET_SWAPPING_LIST_SUCCESS",
    GET_SWAPPING_LIST_FAILURE: "GET_SWAPPING_LIST_FAILURE",

    GET_SWAPPINGDETAIL_LIST_REQUEST: "GET_SWAPPINGDETAIL_LIST_REQUEST",
    GET_SWAPPINGDETAIL_LIST_SUCCESS: "GET_SWAPPINGDETAIL_LIST_SUCCESS",
    GET_SWAPPINGDETAIL_LIST_FAILURE: "GET_SWAPPINGDETAIL_LIST_FAILURE",

    GET_MERCHANT_LIST_REQUEST: "GET_MERCHANT_LIST_REQUEST",
    GET_MERCHANT_LIST_SUCCESS: "GET_MERCHANT_LIST_SUCCESS",
    GET_MERCHANT_LIST_FAILURE: "GET_MERCHANT_LIST_FAILURE",

    GET_NOTIFICATION_LIST_REQUEST: "GET_NOTIFICATION_LIST_REQUEST",
    GET_NOTIFICATION_LIST_SUCCESS: "GET_NOTIFICATION_LIST_SUCCESS",
    GET_NOTIFICATION_LIST_FAILURE: "GET_NOTIFICATION_LIST_FAILURE",

    GET_MERCHANT_REQUEST_DET_LIST_REQUEST: "GET_MERCHANT_REQUEST_DET_LIST_REQUEST",
    GET_MERCHANT_REQUEST_DET_LIST_SUCCESS: "GET_MERCHANT_REQUEST_DET_LIST_SUCCESS",
    GET_MERCHANT_REQUEST_DET_LIST_FAILURE: "GET_MERCHANT_REQUEST_DET_LIST_FAILURE",


    GET_PROFILE_LIST_REQUEST: "GET_PROFILE_LIST_REQUEST",
    GET_PROFILE_LIST_SUCCESS: "GET_PROFILE_LIST_SUCCESS",
    GET_PROFILE_LIST_FAILURE: "GET_PROFILE_LIST_FAILURE",


};
